module.exports = __webpack_public_path__ + "img/icon_fb_hover.37d60290.svg";